import { useState } from 'react';
import { Calendar, AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useGoogleCalendarStatus } from '@/hooks/useGoogleCalendarStatus';
import { GoogleCalendarDialog } from '@/components/integrations/GoogleCalendarDialog';

export function GoogleCalendarReconnectBadge() {
  const { needsReconnect, isChecking, hasConnection } = useGoogleCalendarStatus();
  const [dialogOpen, setDialogOpen] = useState(false);

  // Don't show anything if no connection exists or still checking or doesn't need reconnect
  if (isChecking || !hasConnection || !needsReconnect) {
    return null;
  }

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setDialogOpen(true)}
        className="h-8 px-3 gap-2 bg-yellow-100 dark:bg-yellow-900/30 border-yellow-300 dark:border-yellow-700 text-yellow-800 dark:text-yellow-200 hover:bg-yellow-200 dark:hover:bg-yellow-900/50"
      >
        <Calendar className="h-4 w-4" />
        <AlertTriangle className="h-3 w-3 text-yellow-600 dark:text-yellow-400" />
        <span className="hidden sm:inline text-sm font-medium">Reconectar Google</span>
      </Button>

      <GoogleCalendarDialog open={dialogOpen} onOpenChange={setDialogOpen} />
    </>
  );
}
